import type { ApiError, ProblemDetailsSchema } from '@/js/libs/api';

import { ErrorCode } from 'src/types.ts';

const IGNORED_CODES = [
  /**
   * 403 code redirects the user to an error page, there is no need to show a notification.
   */
  ErrorCode.Forbidden,
  /**
   * 422 code is for form validation errors refs: #9608
   * should be handled by catch block where the request was made with useHandleSubmitErrors
   */
  ErrorCode.InvalidForm,
  /**
   * 401 code triggers forced logout, or reverts the impersonation, with a notification of its own, no need to show an
   * additional notification.
   */
  ErrorCode.Unauthorized,
] as const;

export const isErrorIgnored = (apiError: ApiError<typeof ProblemDetailsSchema>): boolean =>
  IGNORED_CODES.some((code) => apiError?.response?.status === code);
